import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-being-hater',
  templateUrl: './being-hater.component.html',
  styleUrls: ['./being-hater.component.css']
})
export class BeingHaterComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'image', url: 'assets/projects/BeingAHater/1.png', title: '1.png' },
    { id: 2, type: 'image', url: 'assets/projects/BeingAHater/2.png', title: '2.png' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
